import { defineMessage } from 'services/localization';

export const messages = {
    paymentDate: defineMessage('payment_date'),
    bankAccount: defineMessage('bank_account'),
    narrative: defineMessage('narrative'),
    details: defineMessage('details'),
    particulars: defineMessage('particulars'),
    code: defineMessage('code'),
    reference: defineMessage('reference'),
};
